import { isPhoneNum, isValidEmail } from "helpers/validation";

const canEdit = () => {
    return false;
}

// Check unregistered user object instead, not user privilege
const shouldShowInviteUserButton = (isEditMode, obj) => {
    return (!isEditMode && obj.status == 'unregistered')
}

const shouldShowDeleteAvatarButton = (isEditMode, obj) => {
    return (isEditMode && (obj.userPrivilege?.profile_image_thumb_url?.includes('avatar1.png') == false));
}

const shouldShowRemoveUserButton = (isEditMode) => {
    return isEditMode;
}

const shouldShowEditButton = (isEditMode) => {
    return !isEditMode;
}

const shouldShowSaveButton = (isEditMode) => {
    return isEditMode;
}
const shouldShowCancelButton = (isEditMode) => {
    return isEditMode;
}

// test covered functions 
const shouldShowPhoneNotVerified = (obj) => {
    return (isPhoneNum(obj.userPrivilege.unconfirmed_phone_number) == true) && (isPhoneNum(obj.userPrivilege.phone_number) == false);
}

const canEditUserPhoneNumber = (isEditMode, obj) => {
    return isEditMode && (obj.userPrivilege?.phone_number == '' || obj.userPrivilege?.phone_number == null);
}

const shouldGreyOutPhoneField = (isEditMode, canEditPhoneField) => {
    return (isEditMode && !canEditPhoneField)
}

const shouldGreyOutEmailField = (isEditMode, canEditEmailField) => {
    return (isEditMode && !canEditEmailField)
}

const shouldShowEmailNotVerified = (obj) => {
    return (isValidEmail(obj.userPrivilege.unconfirmed_email) == true) && (isValidEmail(obj.userPrivilege.email) == false);
}

const canEditUserEmail = (isEditMode, obj) => {
    return isEditMode && (!isValidEmail(obj.userPrivilege.email)) ;
}

export default {
    canEdit,
    shouldShowInviteUserButton,
    shouldShowRemoveUserButton,
    shouldShowEditButton,
    shouldShowSaveButton,
    shouldShowCancelButton,
    shouldShowDeleteAvatarButton,
    shouldShowPhoneNotVerified,
    shouldShowEmailNotVerified,
    canEditUserPhoneNumber,
    canEditUserEmail,
    shouldGreyOutPhoneField,
    shouldGreyOutEmailField,
}